import { shopModeApi } from "../../api/shopMode";

/**
 * The adapter that points `LogWasteModal` at the JWT₃ floor routes instead of
 * the CRM `api`.
 *
 * It lived in three files as three identical copies (the waste flow, the scan
 * flow and the stock table). G-73 collapsed them, because the copies had
 * already started to matter: each one declared `logWaste` taking ONE argument,
 * so when the modal gained an optional photo every floor surface would have
 * dropped it silently — TypeScript accepts a narrower function where a wider
 * one is expected, so nothing would have complained and no florist's photo
 * would ever have arrived.
 *
 * `locationId` is accepted and ignored on purpose: the floor batch route takes
 * the shop from the kiosk token's `loc` claim, and a caller-supplied shop is
 * exactly what a floor route must never honour.
 */
export const floorInventoryEndpoints = {
  listActiveBatches: (params: {
    locationId: string;
    itemId: string;
    zoneId?: string;
  }) =>
    shopModeApi.floorListActiveBatches({
      itemId: params.itemId,
      zoneId: params.zoneId,
    }),
  logWaste: (
    payload: Parameters<typeof shopModeApi.floorLogWaste>[0],
    photo?: File | null,
  ) => shopModeApi.floorLogWaste(payload, photo),
};
